<template>
    <section class="app-main">
        <!-- 商品操作记录 -->
        <div class="top-bar">
            <el-input placeholder="输入商品名称" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData"  height="600" style="width: 100%">
                <el-table-column prop="goods_id" label="商品ID" align="center" width="100"></el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="操作内容" align="center" show-overflow-tooltip width="220"></el-table-column>
                <el-table-column prop="created_at" label="操作时间" align="center"></el-table-column>
                <el-table-column prop="name" label="操作用户" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="description" label="备注" align="center"></el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" :page-size="size" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>
    </section>
</template>



<script>
import { record_list } from '@/api/goods.js'

export default {
    data() {
        return {
            title:'',
            page:1,
            total:0,
            size: 0,
            tableData:[],
            value: ''
        }
    },
    methods: {
        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            let params = {
                page:this.page
            }
            if(this.value != ""){
                params.search = this.value;
            }
            record_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
            this.table_load = true;
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
    },
    activated(){
        this.getData()
    }
}
</script>

<style lang="less" scoped>

</style>


